import { getBranch } from "utils/utils";
import moment from "moment";
import { UPDATE_SEARCHTDATA_DANHSACHDONDATHANG } from "../../actions/DanhSachDonDatHang/actionTypes";
import { getUserLogin } from "../../utils/utils";

const initialState = {
  tuNgay: moment(new Date()).format("YYYY-MM-DD"),
  denNgay: moment(new Date()).format("YYYY-MM-DD"),
  typeDate: "11",
  sTrangThai: "-1",
  sSearch: "",
  sUserName: getUserLogin().UserName,
  sCustomerName: "",
  iTrangThaiTruKho: -1,
  iTrangThaiThanhToan: 0,
  iBranch: getBranch(),
  sBranch: getBranch(),
  sNVKDUserName: "",
  lstNhomKH: "",
  iLoaiDon: 2,
  iLoaiDoiTac: 0,
  iPageIndex: 1,
  iPageSize: 20,
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchDanhSachDonDatHang = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DANHSACHDONDATHANG:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDanhSachDonDatHang;
